export const LOCAL_CONFIG = {
    IS_PROD: false,
    IS_LOCAL: false,
    DISABLE_ANALYTICS: false,
    API_PATH: 'https://cflocal.com:8000/',
    HOMEPAGE: 'http://cflocal.com:5000/',
    COOKIE_DOMAIN: '.cflocal.com',
    SEGMENT_KEY: 'U7PDcvLsT6MBiCMg73BM5FZI7quT0X11',
    'STRIPE': 'pk_test_7WxyNu2Ez44dmcDBKkiC62gh00CXaZUrMB',
    INTEGRATIONS: [function () {
        $("body").append('<script id="calendlyWidget" src="https://assets.calendly.com/assets/external/widget.js" type="text/javascript" async></script>');
    }],
    INTERCOM_TOUR_ID: 224840,
    DEMO_REPORT_ID: 74,
};
